import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlogBlockQuote } from '../blog.models';

@Component({
  selector: 'app-blog-block-quote',
  templateUrl: './block-quote.component.html',
  styleUrls: ['./block-quote.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogBlockQuoteComponent {
  @Input({ required: true }) block!: BlogBlockQuote;
}
